import { RouterHelper } from '@getaccept/lib-shared/src/helpers/router.helper';
import type { Directory } from '@getaccept/lib-shared/src/types/directory';
import type { Breadcrumb } from '../../../types/Breadcrumb';

export class DirectoryHelper {
  static createPath(directory: Directory): string {
    return `${directory.directory}${directory.title}/`;
  }

  static isSelected(directory: Directory, activePath: string) {
    const path = DirectoryHelper.createPath(directory);
    return path === activePath;
  }

  static validate(text: string): boolean {
    const regExp = new RegExp('/|{|}|\\\\', 'g');
    const matches: RegExpMatchArray = text.match(regExp);
    return text.length > 0 && !matches;
  }

  static createPathFromBreadcrumbs(breadcrumbs: Breadcrumb[], index: number): string {
    const path: string[] = breadcrumbs.map((crumb: Breadcrumb): string => crumb.label);
    return `${path.slice(0, index + 1).join('/')}/`;
  }

  static sliceBreadcrumbs(breadcrumbs: Breadcrumb[], index: number): string[] {
    const crumbs: string[] = breadcrumbs.map((crumb: Breadcrumb): string => crumb.label);
    return crumbs.slice(0, index + 1);
  }

  static removeItems(breadcrumbs: Breadcrumb[], index: number): Breadcrumb[] {
    breadcrumbs.length = index + 1;
    return breadcrumbs;
  }

  static encodeQueryParameter(directory = '/'): string {
    return RouterHelper.encodeQueryParameter(directory);
  }

  static decodeQueryParameter(encodedDirectory: string): string {
    return encodedDirectory ? RouterHelper.decodeQueryParameter(encodedDirectory) : '/';
  }
}
